import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { Sparkles, ArrowRight } from "lucide-react";

const ease = [0.16, 1, 0.3, 1];

export default function PendulumTeaser() {
  return (
    <section className="px-6 lg:px-10 py-6 sm:py-10" data-testid="pendulum-teaser">
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.8, ease }}
        className="mx-auto max-w-[1100px] relative overflow-hidden rounded-sm border border-[#C9A24B]/25 bg-gradient-to-r from-[#1F130E] via-[#241322] to-[#1F130E]"
      >
        <div className="absolute -left-10 -top-10 w-40 h-40 rounded-full bg-[#9C2A52]/20 blur-[70px]" aria-hidden="true" />
        <div className="relative flex flex-col sm:flex-row sm:items-center sm:justify-between gap-6 px-7 py-7 sm:px-10 sm:py-8">
          <div className="flex items-start sm:items-center gap-4">
            <span className="shrink-0 w-11 h-11 rounded-full border border-[#C9A24B]/40 flex items-center justify-center glow-gold">
              <Sparkles className="w-5 h-5 text-[#C9A24B]" strokeWidth={1.4} />
            </span>
            <div>
              <span className="text-[10px] tracking-[0.3em] uppercase text-[#C9A24B]">✦ Just have one question? ✦</span>
              <h2 className="mt-1 font-display text-2xl sm:text-3xl text-[#EFE3CC] leading-tight">
                A quick <span className="italic text-gold-gradient">yes or no</span> — only <span className="text-gold-gradient">$10</span>
              </h2>
              <p className="mt-1 text-sm text-[#B7A488] font-light max-w-md">
                Ask the pendulum a single burning question. Answered by live chat or a short video within 24 hours.
              </p>
            </div>
          </div>
          <Link
            to="/pricing"
            data-testid="pendulum-teaser-cta"
            className="group shrink-0 inline-flex items-center justify-center gap-2 rounded-full bg-gradient-to-r from-[#9C2A52] to-[#C77E8A] px-8 py-3.5 text-xs tracking-[0.2em] uppercase text-[#EFE3CC] shadow-[0_0_30px_rgba(156,42,82,0.3)] transition-transform duration-300 hover:scale-[1.03]"
          >
            Ask the Pendulum
            <ArrowRight className="w-4 h-4 transition-transform duration-300 group-hover:translate-x-1" strokeWidth={1.8} />
          </Link>
        </div>
      </motion.div>
    </section>
  );
}
